
    import './styles.scoped.css';
    export default {
  "modal-root": "awsui_modal-root_rkh1e_1yimk_5"
};
  